import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { Sidebar, Icon, Segment, Menu } from "semantic-ui-react";
import { signout as signoutAction } from "../../store/actions/authActions";
import { update } from "../../store/actions/localActions";

function MenuRow({
  title,
  icon,
  type,
  onClick,
  groupId,
  onHide,
}) {
  const dispatch = useDispatch();

  const handleUpdateLocal = (data) => dispatch(update(data));

  return (
    <div
      key={title}
      className={`menu-row${type === "noHover" ? " noHover" : ""}${
        type === "subMenu" ? " noIcon" : ""
      }`}
      onClick={onClick}
    >
      {type !== "subMenu" ? (
        <div className="menu-row-icon">
          <Icon name={icon} size="large" />
        </div>
      ) : null}
      <div className="menu-row-text">{title}</div>
      {type === "menu" ? (
        <>
          <div className="menu-row-icon">
            <Icon name="angle right" size="large" />
          </div>
          <SubMenu
            groupId={groupId}
            updateLocal={handleUpdateLocal}
            onHide={onHide}
          />
        </>
      ) : null}
    </div>
  );
}

MenuRow.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string,
  groupId: PropTypes.string,
  onHide: PropTypes.func,
};

function SubMenu({ updateLocal, onHide, groupId }) {
  return (
    <div className="sub-menu">
      <MenuRow type="noHover" />
      <MenuRow
        key={groupId + "-Home"}
        title="Home"
        type="subMenu"
        onClick={() => {
          onHide();
          updateLocal({ currentTab: "home" });
        }}
      />
      <MenuRow
        key={groupId + "-User"}
        title="Users"
        type="subMenu"
        onClick={() => {
          onHide();
          updateLocal({ currentTab: "users" });
        }}
      />
    </div>
  );
}

SubMenu.propTypes = {
  updateLocal: PropTypes.func,
  onHide: PropTypes.func,
  groupId: PropTypes.string,
};

function SideBarWrapper({
  children,
  showSideBar,
  onHide,
  user,
}) {
  const dispatch = useDispatch();

  const handleUpdateLocal = (data) => dispatch(update(data));
  const handleSignout = () => dispatch(signoutAction());

  const _activeGroup = localStorage.getItem("activeGroup");

  return (
    <Sidebar.Pushable as={Segment}>
      <Sidebar
        as={Menu}
        animation="overlay"
        icon="labeled"
        vertical
        onHide={() => onHide()}
        visible={showSideBar}
        width="wide"
      >
        <div className="sidebar-top">
          <MenuRow icon="close" onClick={() => onHide()} />
          <MenuRow
            icon="home"
            key="Home"
            title="Home"
            onClick={() => {
              onHide();
              handleUpdateLocal({ currentTab: "home" });
            }}
          />
          {user.isLeader(_activeGroup) ? (
            <MenuRow
              icon="users"
              key="Users"
              title="Users (Beta)"
              onClick={() => {
                onHide();
                handleUpdateLocal({ currentTab: "users" });
              }}
            />
          ) : null}
          {user.isGroupAdmin(_activeGroup) ? (
            <MenuRow
              icon="add to calendar"
              key="Events"
              title="Events"
              onClick={() => {
                onHide();
                handleUpdateLocal({ currentTab: "events" });
              }}
            />
          ) : null}
          {user.admin ? (
            <MenuRow
              icon="server"
              title="Jobs"
              onClick={() => {
                onHide();
                handleUpdateLocal({
                  currentTab: "jobs",
                });
              }}
            />
          ) : null}
        </div>
        <div className="sidebar-bottom">
          <MenuRow
            title="Settings"
            icon="cog"
            onClick={() => {
              onHide();
              handleUpdateLocal({
                currentTab: "settings",
              });
            }}
          />
          <MenuRow
            title="Sign Out"
            icon="sign-out"
            onClick={() => {
              onHide();
              handleSignout();
            }}
          />
        </div>
      </Sidebar>

      <Sidebar.Pusher style={{ height: "100%" }}>{children}</Sidebar.Pusher>
    </Sidebar.Pushable>
  );
}

SideBarWrapper.propTypes = {
  children: PropTypes.node,
  showSideBar: PropTypes.bool,
  onHide: PropTypes.func,
  user: PropTypes.object,
};

export default SideBarWrapper;
